import { NgModule } from '@angular/core';
import { NgxPlayerVideoCreateComponent } from './ngx-player-video-create/ngx-player-video-create.component';
import { CommonModule } from '@angular/common';
import { NgxCvbspPlayerModule } from 'ngx-cvbsp-player';
import { FormsModule } from '@angular/forms';
import { NgxContenteditableModule } from '@vlemaitre/ngx-contenteditable';
import { NgxCvbspAuthorToolModule } from '@vlemaitre/ngx-cvbsp-author-tool';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxCvbspUploaderModule } from '@vlemaitre/ngx-cvbsp-uploader';

@NgModule({
  declarations: [NgxPlayerVideoCreateComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxCvbspPlayerModule,
    NgxCvbspAuthorToolModule,
    NgxContenteditableModule,
    NgxCvbspUploaderModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule
  ],
  exports: [NgxPlayerVideoCreateComponent],
  entryComponents: [NgxPlayerVideoCreateComponent]
})
export class NgxPlayerVideoCreateModule { }
